// frontend/src/components/document-explorer/FolderBreadcrumb.js
// Clickable "Client / Matter / Subfolder" path bar for the folder browser,
// shared by DocumentExplorer.js's case and client modes.
import React from 'react';

const TYPE_ICONS = {
  client: 'bi-person-vcard',
  matter: 'bi-briefcase',
  folder: 'bi-folder2',
  unfiled: 'bi-folder-x',
};

export default function FolderBreadcrumb({ path, onNavigate }) {
  if (!path || path.length === 0) return null;

  return (
    <nav className="flex items-center gap-1 text-sm text-gray-600 px-3 py-2 bg-gray-50 border-b border-gray-200 overflow-x-auto whitespace-nowrap">
      {path.map((seg, i) => {
        const isLast = i === path.length - 1;
        return (
          <React.Fragment key={seg.id}>
            {i > 0 && <i className="bi bi-chevron-right text-gray-400" style={{ fontSize: '0.65rem' }}></i>}
            <button
              type="button"
              onClick={() => !isLast && onNavigate(i)}
              disabled={isLast}
              className={isLast ? 'font-semibold text-gray-800 cursor-default' : 'text-blue-600 hover:underline'}
            >
              {TYPE_ICONS[seg.type] && <i className={`bi ${TYPE_ICONS[seg.type]} mr-1`}></i>}
              {seg.name}
            </button>
          </React.Fragment>
        );
      })}
    </nav>
  );
}
